import { GeneralError } from '@/shared/components'

type ExtAppFetchingErrorProps = {
  refetch: () => void
}

export default function ExtAppFetchingError({ refetch }: ExtAppFetchingErrorProps) {
  return <GeneralError title='Failed to load external applications' onClick={refetch} />
}